export function sortAll(list) {
  list.sort(function(a,b) {
    let timestampA = new Date(a.updatedAt).getTime()
    let timestampB = new Date(b.updatedAt).getTime()
    return timestampB - timestampA
  })
}

export function sortPriceIncrease(list) {
  list.sort(function(a,b) {
    return a.currentPrice - b.currentPrice
  })
}

export function sortPriceDescrease(list) {
  list.reverse(function(a,b) {
    return a.currentPrice - b.currentPrice
  })
}

export function sortIdIncrease(list) {
  list.sort(function(a,b) {
    return a.nft.tokenId - b.nft.tokenId
  })
}

export function sortIdDescrease(list) {
  list.reverse(function(a,b) {
    return a.nft.tokenId - b.nft.tokenId
  })
}

export function sortRarityIncrease(list) {
  list.sort(function(a,b) {
    return a.nft.point - b.nft.point
  })
}

export function sortRarityDescrease(list) {
  list.reverse(function(a,b) {
    return a.nft.point - b.nft.point
  })
}